import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ApplicationStates } from '../../../../reducers/index.config';
import type { ProviderType } from '../../../../core/service/identity/interface/identity.request';

export interface Profile {
  name: string;
  jobTitle: string;
  company: string;
  industry: string,
  email: string,
  id: string,
  teamId: string,
  providers: ProviderType[],
}

export interface ProfileState {
  profile: Profile;
  loading: boolean;
  loaded: boolean;
  error: any;
}

export const initialProfileState: ProfileState = {
  profile: {
    name: '',
    company: '',
    industry: '',
    jobTitle: '',
    email: '',
    id: '',
    teamId: '',
    providers: [],
  },
  loading: false,
  loaded: false,
  error: null,
};

export const getProfileState = createFeatureSelector<ProfileState>(ApplicationStates.PROFILE);
export const getUserProfile = createSelector(getProfileState, (state: ProfileState) => state.profile);
